module.exports = __webpack_public_path__ + "img/kxwz.8c0e6d5f.png";